import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useCurrentScope } from '../../../shared/scope/useCurrentScope.js';
import { createDeal, getDealsQueryKey, type CreateDealInput, type DealListItem } from '../api/deals.client.js';

export function useCreateDealMutation() {
  const queryClient = useQueryClient();
  const scope = useCurrentScope();
  const workspaceId = scope?.workspaceId ?? 'anonymous';
  const queryKey = getDealsQueryKey(workspaceId).slice(0, 2);

  return useMutation<DealListItem, Error, CreateDealInput>({
    mutationFn: async (input) => createDeal(input),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey });
    },
  });
}
